module.exports = __webpack_public_path__ + "static/media/dollar.a3db7334.svg";